export enum SelectEducationFormatEnum {
  courses = 'course_education',
  education = 'formal_education',
}
